export class AsyncEventEmitterSubscriber<T, R = void> {
  private callback: (func: T) => Promise<R>;

  constructor(callback: (func: T) => Promise<R>)
  {
    this.callback = callback;
  }

  public async call(value?: T): Promise<R>
  {
    return await this.callback(value);
  }
}

export class AsyncEventEmitter<T, R = void>
{
  private subscriptions: Array<AsyncEventEmitterSubscriber<T, R>> = [];

  public subscribe(callback: any): AsyncEventEmitterSubscriber<T, R>
  {
    const subscriber = new AsyncEventEmitterSubscriber<T, R>(callback);
    this.subscriptions.push(subscriber);
    return subscriber;
  }

  public unsubscribe(subscriber: AsyncEventEmitterSubscriber<T, R>): void
  {
    this.subscriptions.splice(this.subscriptions.indexOf(subscriber), 1);
  }

  public async emit(value?: T): Promise<Array<R>>
  {
    return await Promise.all(this.subscriptions.map(s => s.call(value)));
  }
}
